import { CMD } from "../menu/commandIds.js";

/** One mappable command: shown in Shortcut Mapper and wired to the global chord map. */
export type ShortcutCatalogRow = {
  commandId: string;
  label: string;
  defaultChord: string;
};

/**
 * Default shortcuts for the WEB shell global handler (keep in sync with former AppShell map).
 */
export const SHORTCUT_CATALOG: readonly ShortcutCatalogRow[] = [
  { commandId: CMD.FILE_NEW, label: "New", defaultChord: "Ctrl+N" },
  { commandId: CMD.FILE_OPEN, label: "Open… (text, image, or PDF)", defaultChord: "Ctrl+O" },
  { commandId: CMD.FILE_OPEN_FOLDER, label: "Open Folder as Workspace…", defaultChord: "Ctrl+Shift+O" },
  { commandId: CMD.FILE_SAVE, label: "Save", defaultChord: "Ctrl+S" },
  { commandId: CMD.FILE_CLOSE, label: "Close", defaultChord: "Ctrl+W" },
  { commandId: CMD.FILE_PRINT, label: "Print…", defaultChord: "Ctrl+P" },
  { commandId: CMD.SEARCH_FIND, label: "Find…", defaultChord: "Ctrl+F" },
  { commandId: CMD.SEARCH_REPLACE, label: "Replace…", defaultChord: "Ctrl+H" },
  { commandId: CMD.SEARCH_GOTOLINE, label: "Go to…", defaultChord: "Ctrl+G" },
  { commandId: CMD.SEARCH_FINDINFILES, label: "Find in Files…", defaultChord: "Ctrl+Shift+F" },
  { commandId: CMD.SEARCH_FINDINDIRECTORY, label: "Find in Directory…", defaultChord: "Ctrl+Shift+D" },
  { commandId: CMD.SEARCH_SETANDFINDNEXT, label: "Select and Find Next", defaultChord: "Ctrl+F3" },
  { commandId: CMD.SEARCH_SETANDFINDPREV, label: "Select and Find Previous", defaultChord: "Ctrl+Shift+F3" },
  { commandId: CMD.SEARCH_VOLATILE_FINDNEXT, label: "Volatile Find Next", defaultChord: "Ctrl+Alt+F3" },
  { commandId: CMD.SEARCH_VOLATILE_FINDPREV, label: "Volatile Find Previous", defaultChord: "Ctrl+Alt+Shift+F3" },
  { commandId: CMD.SEARCH_FINDINCREMENT, label: "Incremental Search…", defaultChord: "Ctrl+Alt+I" },
  { commandId: CMD.SEARCH_GOTOMATCHINGBRACE, label: "Go to Matching Brace", defaultChord: "Ctrl+B" },
  { commandId: CMD.EDIT_SELECTALL, label: "Select All", defaultChord: "Ctrl+A" },
  { commandId: CMD.EDIT_UNDO, label: "Undo", defaultChord: "Ctrl+Z" },
  { commandId: CMD.EDIT_REDO, label: "Redo", defaultChord: "Ctrl+Y" },
  { commandId: CMD.EDIT_LINE_UP, label: "Move Up Current Line", defaultChord: "Ctrl+Shift+Up" },
  { commandId: CMD.EDIT_LINE_DOWN, label: "Move Down Current Line", defaultChord: "Ctrl+Shift+Down" },
  { commandId: CMD.SEARCH_FINDNEXT, label: "Find Next", defaultChord: "F3" },
  { commandId: CMD.SEARCH_FINDPREV, label: "Find Previous", defaultChord: "Shift+F3" },
  { commandId: CMD.VIEW_FULLSCREEN, label: "Toggle Full Screen Mode", defaultChord: "F11" },
  { commandId: CMD.VIEW_MULTIVIEW, label: "Multiview (split editors)", defaultChord: "Ctrl+Alt+M" },
  { commandId: CMD.VIEW_SINGLE_EDITOR, label: "Single editor view", defaultChord: "" },
  { commandId: CMD.VIEW_GIT_TERMINAL, label: "Git terminal", defaultChord: "" },
  { commandId: CMD.FILE_OPEN_HTML_URL, label: "Open HTML from URL", defaultChord: "" },
  { commandId: CMD.WINDOW_TAB_MOVE_LEFT, label: "Move tab left", defaultChord: "Ctrl+Shift+PageUp" },
  { commandId: CMD.WINDOW_TAB_MOVE_RIGHT, label: "Move tab right", defaultChord: "Ctrl+Shift+PageDown" },
] as const;

const CATALOG_IDS = new Set(SHORTCUT_CATALOG.map((r) => r.commandId));

export function isShortcutCatalogCommandId(id: string): boolean {
  return CATALOG_IDS.has(id);
}

export function defaultChordByCommandId(): ReadonlyMap<string, string> {
  return new Map(SHORTCUT_CATALOG.map((r) => [r.commandId, r.defaultChord]));
}
